import clsx from 'clsx'
import React, { FC } from 'react'

import FacebookIcon from '@Assets/SVG/SocialMedia/Facebook'
import InstagramIcon from '@Assets/SVG/SocialMedia/InstagramColored'
import TikTokIcon from '@Assets/SVG/SocialMedia/TiktokColored'
import { Video, VideoProps } from '@Components/CMS/Video'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { PictureV2 } from '@Components/Image'
import { ProductTileProps } from '@Domains/Product/Tiles/types'
import { LinkField } from '@Generated/graphql'
import { Image as ImageData } from '@Globals/Image'

import styles from './MediaGalleryCard.module.scss'

type MediaGalleryDisplayTypes =
  | 'media_caption'
  | 'product_price'
  | 'product_name'

export interface MediaGalleryVideo {
  videoId: string
  videoMobileId: string
  videoType: VideoProps['videoType']
}

export interface MediaGalleryCardProps {
  caption?: string
  display: MediaGalleryDisplayTypes[]
  icon?: string
  id?: string
  image: ImageData | null
  link?: LinkField
  linkID?: string
  linkType?: string
  mobileImage?: ImageData | null
  onClick?: () => void
  products?: ProductTileProps[]
  someHandle?: string
  title?: string
  video: MediaGalleryVideo | null
}
export const MediaGalleryCard: FC<Omit<MediaGalleryCardProps, 'linkType'>> = ({
  caption,
  display,
  icon,
  image,
  link,
  onClick,
  products,
  someHandle,
  video,
}) => {
  const someIcons = {
    Facebook: FacebookIcon,
    Instagram: InstagramIcon,
    'Tik-Tok': TikTokIcon,
  }

  return (
    <div className={styles.mediaGalleryCardWrapper}>
      <div className={clsx(styles.mediaGalleryImageWrapper, !!link && styles.hasPointer)} onClick={onClick}>
        <div className={styles.mediaGalleryCardImage}>
          {image !== null && (
            <PictureV2
              breakpoints={[
                [320, 270],
                [480, 270],
                [768, 300],
                [800, 310],
                [1000, 375],
                [1200, 380],
                [1600, 500],
              ]}
              cropOnMobile
              cropRatio="310:310"
              desktop={image}
              loading="lazy"
              mobile={image}
              objectFit="cover"
              objectPosition="center center"
            />
          )}

          {video != null && (
            <Video
              blockIndex={5}
              caption={caption}
              desktopCropping="top"
              desktopMaxHeight="100"
              disableControls
              fillContainer
              settings={{ autoplay: true }}
              type="fill-container"
              videoId={video?.videoId}
              videoMobileId={video?.videoMobileId}
              videoType={video?.videoType}
              withMargin
            />
          )}

        </div>
        <div className={styles.mediaGalleryCardSoMe}>
          {icon && <SVGIcon className={styles.mediaGalleryCardSoMeIcon} icon={someIcons[icon]} />}
          {someHandle}
        </div>
      </div>

      {(display.length > 0) && (
        <div className={styles.mediaGalleryProduct}>
          <div className={styles.mediaGalleryProductInfo}>
            {(display.includes('product_name') && !!products?.length) && (
              <div className={styles.mediaGalleryProductTitle}>
                {products[0].title}
              </div>
            )}

            {display.includes('media_caption') && caption && (
              <div className={styles.mediaGalleryProductTitle}>
                {caption}
              </div>
            )}

            {(display.includes('product_price') && !!products?.length) && (
              <div className={styles.mediaGalleryProductPrice}>
                {products[0].price}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
